import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/home_new_left_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-64f2d910"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "laryd" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1 /* HOISTED */))
const _hoisted_4 = { class: "right-icon" }
const _hoisted_5 = {
  key: 1,
  class: "laryd-box"
}
const _hoisted_6 = { class: "laryd-xscr" }
const _hoisted_7 = { class: "firstBox" }
const _hoisted_8 = { class: "day day_top" }
const _hoisted_9 = { class: "cenBox" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "day" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  class: "laryd-xscr-enc-conet",
  style: {"margin-left":"10px","margin-top":"8px"}
}
const _hoisted_14 = { class: "van-ellipsis" }
const _hoisted_15 = { style: {"display":"flex","flex-direction":"column","align-items":"center","height":"100%","justify-content":"center"} }
const _hoisted_16 = {
  class: "team_logo",
  alt: ""
}
const _hoisted_17 = {
  class: "van-ellipsis",
  style: {"margin-top":"6px","max-width":"54px"}
}
const _hoisted_18 = {
  class: "laryd-xscr-enc-conet",
  style: {"width":"42px"}
}
const _hoisted_19 = {
  key: 0,
  class: "laryd-xscr-enc-score"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10px","margin":"1px"} }, ":", -1 /* HOISTED */))
const _hoisted_21 = {
  key: 1,
  class: "laryd-xscr-enc-time",
  style: {"margin-right":"10px"}
}
const _hoisted_22 = { class: "laryd-xscr-enc-conet" }
const _hoisted_23 = {
  key: 0,
  class: "laryd-xscr-enc-live"
}
const _hoisted_24 = { style: {"color":"#F80D1B"} }
const _hoisted_25 = { alt: "" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { style: {"display":"flex","flex-direction":"column","align-items":"center","height":"100%","justify-content":"center"} }
const _hoisted_28 = {
  class: "team_logo",
  alt: ""
}
const _hoisted_29 = {
  class: "van-ellipsis",
  style: {"margin-top":"6px","max-width":"54px"}
}
const _hoisted_30 = {
  key: 2,
  class: "laryd-box"
}
const _hoisted_31 = { class: "laryd-title" }
const _hoisted_32 = { class: "anchor" }
const _hoisted_33 = {
  key: 0,
  class: "nomore-data-class"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"50px"} }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_notice_bar = _resolveComponent("van-notice-bar")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: $setup.refreshing,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.refreshing) = $event)),
      onRefresh: $setup.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: $setup.loading,
          offset: 100,
          finished: $setup.finished,
          "finished-text": _ctx.$t('tips.nomoredata'),
          onLoad: $setup.onLoad
        }, {
          default: _withCtx(() => [
            _createCommentVNode(" <Swiper /> "),
            _createElementVNode("div", _hoisted_2, [
              ($setup.cloumnBanner.length > 0)
                ? _withDirectives((_openBlock(), _createBlock(_component_van_notice_bar, {
                    key: 0,
                    scrollable: false,
                    background: "#f8f8f8",
                    style: {"height":"28px"},
                    color: "#0D0D0D"
                  }, {
                    "left-icon": _withCtx(() => [
                      _hoisted_3
                    ]),
                    "right-icon": _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_van_icon, {
                          name: "arrow",
                          color: "#0D0D0D"
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_van_swipe, {
                        vertical: "",
                        class: "notice-swipe",
                        autoplay: 3000,
                        "show-indicators": false
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cloumnBanner, (item) => {
                            return (_openBlock(), _createBlock(_component_van_swipe_item, {
                              onClick: ($event: any) => ($setup.onNotice(item))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 512 /* NEED_PATCH */)), [
                    [_vShow, false]
                  ])
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" 今日热赛 "),
              ($setup.todaydata.length > 0 && $setup.showMatch)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createCommentVNode(" 热门推荐 "),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString($setup.dayjs().month() + 1) + "-" + _toDisplayString($setup.dayjs().date()), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("img", {
                            src: $setup.host_tag,
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_10)
                        ]),
                        _createElementVNode("div", _hoisted_11, _toDisplayString($setup.todaydata.length) + _toDisplayString(_ctx.$t('match.chang')), 1 /* TEXT */)
                      ]),
                      _createCommentVNode(" 今日赛程 "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.todaydata, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "laryd-xscr-enc",
                          key: index,
                          onClick: ($event: any) => ($setup.toLiveRoom(item))
                        }, [
                          _createCommentVNode(" 左 "),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(item.short_name_zh), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_15, [
                              _withDirectives(_createElementVNode("img", _hoisted_16, null, 512 /* NEED_PATCH */), [
                                [_directive_lazy, item.home_log]
                              ]),
                              _createElementVNode("span", _hoisted_17, _toDisplayString(item.home_name), 1 /* TEXT */)
                            ])
                          ]),
                          _createCommentVNode(" 中 "),
                          _createElementVNode("div", _hoisted_18, [
                            ((item.status_id > 1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createElementVNode("span", {
                                    style: _normalizeStyle($setup.Match.getHomeScore(item) > $setup.Match.getAwayScore(item) ? 'color: #0D0D0D;' : 'color: #898989;')
                                  }, _toDisplayString($setup.Match.getHomeScore(item)), 5 /* TEXT, STYLE */),
                                  _hoisted_20,
                                  _createElementVNode("span", {
                                    style: _normalizeStyle($setup.Match.getHomeScore(item) > $setup.Match.getAwayScore(item) ? 'color: #898989;' : 'color: #0D0D0D;')
                                  }, _toDisplayString($setup.Match.getAwayScore(item)), 5 /* TEXT, STYLE */)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('tips.today')), 1 /* TEXT */),
                                  _createElementVNode("span", null, _toDisplayString($setup.matchListTime(item.match_time)), 1 /* TEXT */)
                                ]))
                          ]),
                          _createCommentVNode(" 右 "),
                          _createElementVNode("div", _hoisted_22, [
                            ((item.status_id > 1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('me.zzzb')), 1 /* TEXT */),
                                  _withDirectives(_createElementVNode("img", _hoisted_25, null, 512 /* NEED_PATCH */), [
                                    [_directive_lazy, $setup.zhibo]
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_26)),
                            _createElementVNode("div", _hoisted_27, [
                              _withDirectives(_createElementVNode("img", _hoisted_28, null, 512 /* NEED_PATCH */), [
                                [_directive_lazy, item.away_log]
                              ]),
                              _createElementVNode("span", _hoisted_29, _toDisplayString(item.away_name), 1 /* TEXT */)
                            ])
                          ])
                        ], 8 /* PROPS */, _hoisted_12))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" 正在热播 "),
              ($setup.hotPlayData.length > 0 || $setup.hotPlaybackList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.index_title_zb')), 1 /* TEXT */),
                      _createElementVNode("p", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.nativeToNewWeb($setup.router, `/MoreRecomm?type=1`)))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('home.more')) + " ", 1 /* TEXT */),
                        _createVNode(_component_van_icon, { name: "arrow" })
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotPlayData, (item, index) => {
                  return (_openBlock(), _createBlock($setup["MatchCell"], {
                    key: index,
                    item: item
                  }, null, 8 /* PROPS */, ["item"]))
                }), 128 /* KEYED_FRAGMENT */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotPlaybackList, (item, index) => {
                  return (_openBlock(), _createBlock($setup["MatchCell"], {
                    key: index,
                    item: item
                  }, null, 8 /* PROPS */, ["item"]))
                }), 128 /* KEYED_FRAGMENT */)),
                ($setup.countryCode == 'vi' && $setup.homeCategoryType_vi == 6 && $setup.hotPlayData.length<4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('当前斗鸡比赛较少，去体育频道看看吧')), 1 /* TEXT */),
                      _createElementVNode("button", { onClick: $setup.jumpToSport }, _toDisplayString(_ctx.$t('前往体育频道')), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["loading", "finished", "finished-text"]),
        _createCommentVNode(" <div v-html=\"h5Foot\" v-if=\"h5Foot !== ''\" class=\"h5Foot\"></div> "),
        _hoisted_34
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}